
const nameList = [
    {
        entityField: "retailId",
        showField: "原单号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "cashierName",
        showField: "收银员",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "coName",
        showField: "货主名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "customerIdCard",
        showField: "顾客身份证",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "customerName",
        showField: "顾客姓名",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "customerPhoneNumber",
        showField: "顾客手机号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "doctorName",
        showField: "开方医师",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "pharmacistName",
        showField: "执业药师",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "recMoney",
        showField: "实收金额",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "totalNumber",
        showField: "总数量",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "createTime",
        showField: "创建时间",
        fieldWeight: 100,
        fieldType: "string",

    },


]



const  searchList= [
    // {
    //     showField: "开始时间",
    //     entityField: "start",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "结束时间",
    //     entityField: "end",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
   
    {
        showField: "卡类型名称",
        entityField: "capName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

    // {
    //     showField: "货主",
    //     entityField: "coName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 4414428383875072,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField:  "coName,coId",
    //     fieldWeight: 120,
    // },
   
    // {
    //     showField: "门店类型",
    //     entityField: "storeType",
    //     isShow: 1,
    //     fieldType: "select",
    //     searchId: null,
    //     formatterContent: [
    //         {
    //             key: "单体",
    //             value: '单体',
    //         },
    //         {
    //             key: "加盟",
    //             value: "加盟",
    //         },
    //         {
    //             key: "直营",
    //             value: "直营",
    //         },
    //         {
    //             key: "批零一体",
    //             value: "批零一体",
    //         },
    //     ],
    //     isRift: null,
    //     riftField: null,
    //     setField: null,
    //     fieldWeight: 120,
    // },
]




// 门店列表
// 业务员列表
export {nameList,searchList}